import React, { Component } from 'react';
import $ from 'jquery';
import { connect } from 'react-redux';
import mapStateToProps from '../../../store/mapStateToProps';
import mapDispatchToProps from '../../../store/mapDispatchToProps';
import { hit } from '../../metrics';
import HelmetSite from '../HelmetSite';
import CaseFooterNew from '../CaseFooterNew';
import './style.css';

const base = '/cases/img/normalno/figma';
const motionBase = '/cases/img/normalno/motion';
const sliderBase = '/cases/img/normalno/slider';

const sliderItems = [
  { src: 'runner.png', alt: 'Герой бежит под дождём' },
  { src: 'excavator.png', alt: 'Экскаватор' },
  { src: 'dog.png', alt: 'Собака со школьным рюкзаком' },
  { src: 'train.png', alt: 'Поезд' },
  { src: 'sleeper.png', alt: 'Герой с подушкой' },
  { src: 'boots.png', alt: 'Ботинки с растением' },
  { src: 'camel.png', alt: 'Герой на верблюде' }
];

const copy = {
  title: 'Как выбрать квартиру похуже?',
  about: 'Сделали для ЖК «Преображенская площадь» интерактивный спецпроект — иронический антигид по выбору жилья, который методично учит, как выбрать квартиру хуже. Такой приём ломает привычный шаблон рекламы недвижимости и выделяет проект в потоке одинаковых подходов.',
  idea: 'Вместо перечисления преимуществ ЖК мы пошли от обратного — собрали пользовательский путь в формате пошаговой инструкции «как сделать себе хуже». Каждый шаг — узнаваемый бытовой компромисс: далёкое метро, шум поездов, перенесённые сроки сдачи.\n\nПриём построен на самоузнавании: пользователь соглашается с абсурдным советом, а к финалу сам понимает — это не мелочи, которые стоит терпеть.',
  content: 'Каждый из десяти разделов — заголовок-приговор («До метро 25 минут — отлично», «Сдача в 2029 — подождём»), короткий ироничный текст и, в части разделов, авторские стихи в духе вредных советов — они доводят абсурдность ситуации до предела и работают лучше любого прямого аргумента.',
  illustrations: 'Иллюстрации выдержаны в приглушённой, почти монохромной палитре — с редкими точечными акцентами цвета, которые выделяют ключевые слова и интерактивные элементы на фоне общей сдержанности.\n\nПод каждый из десяти «вредных советов» нарисована отдельная сюжетная сцена со сквозным персонажем, который проходит через все ситуации проекта — от пробежки под дождём до стройки с экскаватором.',
  structure: 'Спецпроект собран как отдельный сайт-путешествие по десяти шагам: с содержанием, нумерацией разделов и постраничной навигацией вперёд-назад. Финальный экран — логичный вывод, который выводит пользователя на сайт ЖК «Преображенская площадь».'
};

const fixPrepositions = value => value.replace(
  /(^|[\s(])((?:без|для|при|над|под|во|до|за|из|на|от|по|а|в|и|к|о|с|у))\s+/gi,
  (match, prefix, preposition) => `${prefix}${preposition}\u00a0`
);

const Visual = ({ name, ratio, alt = '' }) => (
  <section className="normalno-visual normalno-gap" style={{ '--normalno-ratio': ratio }}>
    <img src={`${base}/${name}.webp`} alt={alt} loading="lazy" />
  </section>
);

const CopySection = ({ title, children, size }) => (
  <section className={`normalno-copy normalno-gap normalno-copy--${size}`}>
    <h2>{title}</h2>
    <p>{fixPrepositions(children)}</p>
  </section>
);

class Normalno extends Component {
  constructor(props) {
    super(props);
    this.siteSection = React.createRef();
    this.siteCard = React.createRef();
    this.posters = React.createRef();
    this.parallaxFrame = null;
  }

  componentDidMount() {
    this.props.setProjectName('normalno');
    $('body').addClass('case-expanded hash-normalno');
    this.props.changeCase(null);
    window.scrollTo(0, 0);
    hit(window.location.pathname);

    this.revealObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          this.revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16 });

    if (this.posters.current) this.revealObserver.observe(this.posters.current);

    this.handleParallax = () => {
      if (this.parallaxFrame) return;
      this.parallaxFrame = window.requestAnimationFrame(() => {
        this.parallaxFrame = null;
        const section = this.siteSection.current;
        const card = this.siteCard.current;
        if (!section || !card) return;

        const rect = section.getBoundingClientRect();
        const centerOffset = (window.innerHeight / 2) - (rect.top + rect.height / 2);
        const limit = window.innerWidth <= 700 ? 24 : 72;
        const shift = Math.max(-limit, Math.min(limit, centerOffset * 0.12));
        card.style.setProperty('--normalno-parallax', `${shift}px`);
      });
    };

    window.addEventListener('scroll', this.handleParallax, { passive: true });
    window.addEventListener('resize', this.handleParallax);
    this.handleParallax();
  }

  componentWillUnmount() {
    $('body').removeClass('hash-normalno');
    if (this.revealObserver) this.revealObserver.disconnect();
    if (this.handleParallax) {
      window.removeEventListener('scroll', this.handleParallax);
      window.removeEventListener('resize', this.handleParallax);
    }
    if (this.parallaxFrame) window.cancelAnimationFrame(this.parallaxFrame);
  }

  render() {
    return (
      <div className="case">
        <div className="case-content" id="case-normalno">
          <section className="normalno-hero">
            <div className="normalno-hero__art">
              <img className="normalno-hero__cloud" src={`${base}/hero-cloud.svg`} alt="" />
              <img className="normalno-hero__title" src={`${base}/hero-title.svg`} alt={copy.title} />
              <img className="normalno-hero__arrow" src={`${base}/hero-arrow.svg`} alt="" />
            </div>
            <video autoPlay muted loop playsInline preload="metadata">
              <source src={`${motionBase}/video.mp4`} type="video/mp4" />
            </video>
          </section>

          <section className="normalno-about">
            <div className="normalno-about__main">
              <h1>{copy.title}</h1>
              <dl>
                <div><dt>Клиент</dt><dd>Regions Development</dd></div>
                <div><dt>Виды работ</dt><dd>Сайт&nbsp;&nbsp;&nbsp; Реклама</dd></div>
              </dl>
            </div>
            <p>{fixPrepositions(copy.about)}</p>
          </section>

          <section className="normalno-site-motion normalno-gap" ref={this.siteSection}>
            <img
              ref={this.siteCard}
              className="normalno-site-motion__card"
              src={`${base}/site-card.webp`}
              alt="Интерактивный сайт спецпроекта"
              loading="lazy"
            />
          </section>
          <CopySection title="Идея" size="idea">{copy.idea}</CopySection>
          <section className="normalno-posters normalno-gap" ref={this.posters}>
            <img src={`${base}/posters.webp`} alt="Серия рекламных постеров" loading="lazy" />
          </section>
          <CopySection title="Контент" size="regular">{copy.content}</CopySection>
          <section className="normalno-perspective normalno-gap">
            <img className="normalno-perspective__desktop" src={`${base}/content.webp`} alt="Разделы и иллюстрации спецпроекта" loading="lazy" />
            <div className="normalno-perspective__mobile">
              <img className="normalno-perspective__aside" src={`${base}/content-left.png`} width="667" height="1080" alt="Правая колонка разделов спецпроекта" loading="lazy" />
              <div className="normalno-perspective__main">
                <img src={`${base}/content-right.png`} width="1234" height="2078" alt="Левая колонка разделов спецпроекта" loading="lazy" />
                <video className="normalno-perspective__metro" autoPlay muted loop playsInline preload="metadata">
                  <source src={`${motionBase}/metro.mp4`} type="video/mp4" />
                </video>
              </div>
            </div>
          </section>
          <CopySection title="Иллюстрации" size="illustrations">{copy.illustrations}</CopySection>
          <section className="normalno-ribbon normalno-gap" aria-label="Персонажи спецпроекта">
            <div className="normalno-ribbon__track">
              {[0, 1].map(group => (
                <div className="normalno-ribbon__group" aria-hidden={group === 1} key={group}>
                  {sliderItems.map(item => (
                    <div className="normalno-ribbon__item" key={`${group}-${item.src}`}>
                      <img
                        src={`${sliderBase}/${item.src}`}
                        alt={group === 0 ? item.alt : ''}
                        loading="lazy"
                      />
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </section>
          <Visual name="billboard" ratio="1920 / 1080" alt="Наружная реклама спецпроекта" />
          <CopySection title="Структура" size="regular">{copy.structure}</CopySection>
          <section className="normalno-visual normalno-structure normalno-gap" style={{ '--normalno-ratio': '1920 / 1088.75' }}>
            <img className="normalno-structure__desktop" src={`${base}/structure.webp`} alt="Структура страниц спецпроекта" loading="lazy" />
            <div className="normalno-structure__mobile">
              <img src={`${base}/structure-left.png`} width="950" height="1080" alt="Левая колонка структуры спецпроекта" loading="lazy" />
              <img src={`${base}/structure-right.png`} width="950" height="1089" alt="Правая колонка структуры спецпроекта" loading="lazy" />
            </div>
          </section>
          <section className="normalno-final normalno-gap" aria-label="Финальный экран спецпроекта">
            <video autoPlay muted loop playsInline preload="metadata">
              <source src={`${motionBase}/man_new.mp4`} type="video/mp4" />
            </video>
            <img src={`${base}/final.webp`} alt="Финальный экран спецпроекта" loading="lazy" />
          </section>

          <CaseFooterNew
            to="/projects/afipark/"
            title="Сиреневый парк"
            img="/cases/img/afipark/afipark.webp"
            full={true}
          />
        </div>
        <HelmetSite title={copy.title} />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Normalno);
